var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoftReboot({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#34485C;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.7,7.7C7.1,4.4,10.9,2.3,15,2c7.8-0.5,14.5,5.3,15,13l2-0.1C31.4,6.1,23.7-0.5,14.9,0 C10.2,0.3,6,2.6,3.2,6.3L1.6,5l-0.4,5l5-1L4.7,7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.6,23.9c-2.4,3.4-6.1,5.6-10.2,6C9.7,30.7,2.8,25.1,2,17.4l-2,0.2C0.9,25.9,7.9,32,16,32 c0.5,0,1.1,0,1.7-0.1c4.6-0.5,8.8-2.9,11.5-6.7l1.6,1.3l0.2-5l-5,1.2L27.6,23.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftReboot);
export default __webpack_public_path__ + "static/media/Soft-Reboot.7a7f048786f38822b919bcf981df3b21.svg";
export { ForwardRef as ReactComponent };